import React from "react";
import { Instagram, Camera, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import { TRUCK_IMAGE } from "../data/images";

const TILES = [
  { type: "img", src: TRUCK_IMAGE, alt: "Taste of Egg food truck Clayton Melbourne", span: "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto" },
  { type: "tag", text: "Egg Bhurji", sub: "Mumbai street style" },
  { type: "tag", text: "Tiranga", sub: "Three flavours, one plate" },
  { type: "tag", text: "Cheese Bhurji", sub: "Molten goodness" },
  { type: "tag", text: "Surti Gotalo", sub: "Smoky · spicy · soul food" },
  { type: "soon", text: "Photo coming soon" },
  { type: "tag", text: "Anda Pulav", sub: "Fragrant basmati" },
  { type: "tag", text: "Half Fry", sub: "Runny yolk magic" },
  { type: "soon", text: "Photo coming soon" },
  { type: "tag", text: "Italian Paplet", sub: "Indian-Italian fusion" },
  { type: "tag", text: "Cuttlesh", sub: "Onion · chilli · coriander" },
  { type: "soon", text: "Photo coming soon" },
];

export default function Gallery() {
  return (
    <div data-testid="page-gallery">
      <PageHeader
        eyebrow="Behind the truck"
        title="Cinematic"
        accent="cravings."
        subtitle="Smoky pans, golden yolks, late-night queues. Real photos coming soon — follow us on Instagram for daily uploads."
      />

      <section className="max-w-7xl mx-auto px-4 md:px-8 pb-12">
        <Reveal>
          <a
            href="https://instagram.com/tasteofegg_australia"
            target="_blank"
            rel="noreferrer"
            className="btn-primary mb-10"
            data-testid="gallery-ig"
          >
            <Instagram className="w-4 h-4" /> Follow @tasteofegg_australia
          </a>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4">
          {TILES.map((t, i) => {
            if (t.type === "img") {
              return (
                <Reveal key={i} delay={i * 0.04}>
                  <div className={`hover-zoom rounded-2xl overflow-hidden h-full ${t.span || ""}`}>
                    <img src={t.src} alt={t.alt} loading="lazy" className="w-full h-full object-cover" />
                  </div>
                </Reveal>
              );
            }
            if (t.type === "soon") {
              return (
                <Reveal key={i} delay={i * 0.04}>
                  <div className="rounded-2xl border border-dashed border-yellow-brand/30 bg-yellow-brand/5 h-full flex flex-col items-center justify-center text-center p-4">
                    <Camera className="w-6 h-6 text-yellow-brand mb-2" />
                    <span className="font-script text-yellow-brand text-2xl">Coming soon</span>
                    <span className="text-white/40 text-[11px] uppercase tracking-widest mt-1">Snap incoming</span>
                  </div>
                </Reveal>
              );
            }
            return (
              <Reveal key={i} delay={i * 0.04}>
                <Link
                  to="/menu"
                  className="rounded-2xl card-dark h-full flex flex-col justify-between p-5 group transition-all duration-500 hover:-translate-y-1"
                >
                  <div className="w-9 h-9 rounded-full bg-yellow-brand/15 text-yellow-brand flex items-center justify-center group-hover:bg-yellow-brand group-hover:text-black transition-colors">
                    <Camera className="w-4 h-4" />
                  </div>
                  <div>
                    <div className="font-script text-yellow-brand text-3xl md:text-4xl leading-none">{t.text}</div>
                    <div className="text-white/55 text-[11px] mt-2 uppercase tracking-widest">{t.sub}</div>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 md:px-8 pb-20">
        <div className="rounded-3xl bg-yellow-brand text-black p-10 md:p-14 text-center">
          <h2 className="text-3xl md:text-5xl font-extrabold balanced">
            Want to see your dish here?{" "}
            <span className="font-script text-5xl md:text-7xl">Tag us.</span>
          </h2>
          <p className="mt-3 text-black/70">Use #tasteofegg on Instagram and we'll feature you.</p>
          <a href="tel:0434508712" className="mt-6 inline-flex items-center gap-2 bg-black text-yellow-brand font-extrabold rounded-full px-7 py-3 hover:bg-black/85 transition-colors" data-testid="gallery-call">
            <Phone className="w-4 h-4" /> 0434 508 712
          </a>
        </div>
      </section>
    </div>
  );
}
